import { register } from "@rill/loader";
import { isAfterToday } from "../utils/date-helpers";

register(
  {
    name: "dayPersonalRecords",
    meta: ["no-bust", "exercise"],
    ttl: "2 hours",
  },
  async ({ api }, { start, end, proxyAthlete, isCheckIn }) => {
    const query = {
      start,
      end,
      isCheckIn,
    };
    if (proxyAthlete) {
      query.proxyAthlete = proxyAthlete;
    }

    if (isAfterToday(end)) return {};

    const res = await api("personal-records", { query });
    const parsedRes = await res.json();
    return parsedRes;
  }
);

// Same underlying endpoint as dayPersonalRecords, registered under a
// separate name so single-day views can load a wide, retroactive-PR-aware
// range (for badge matching against locals.dayPersonalRecordsRange) without
// disturbing dayPersonalRecords' exact-day scope (used by PersonalRecordsCard
// to show only PRs literally set on the viewed day).
register(
  {
    name: "dayPersonalRecordsRange",
    meta: ["no-bust", "exercise"],
    ttl: "2 hours",
  },
  async ({ api }, { start, end, proxyAthlete, isCheckIn }) => {
    const query = {
      start,
      end,
      isCheckIn,
    };
    if (proxyAthlete) {
      query.proxyAthlete = proxyAthlete;
    }

    if (isAfterToday(end)) return {};

    const res = await api("personal-records", { query });
    const parsedRes = await res.json();
    return parsedRes;
  }
);
